var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "PopUp",
        {
          attrs: {
            title: "Unsere Webseite verwendet Cookies",
            size: "lg",
            "hide-actions": "",
            closable: _vm.closable
          }
        },
        [
          _c("div", { staticClass: "consent-popup" }, [
            _c("div", { staticClass: "intro" }, [
              _vm._v(
                '\n\t\t\tWeitere Informationen zu Cookies erhalten Sie in diesem Cookiebanner und in unserer Datenschutzerklärung\n\t\t\t(siehe unten). Klicken Sie auf "Alle Cookies erlauben", um alle Arten von Cookies zu akzeptieren oder\n\t\t\tklicken Sie auf "Nur erforderliche Cookies erlauben" um nur jene Cookies zu zulassen, die für den\n\t\t\tBetrieb und Funktion der Webseite unbedingt erforderlich sind.\n\t\t'
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              { staticClass: "categories" },
              _vm._l(_vm.categories, function(category) {
                return _c(
                  "div",
                  { key: category.key },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "consent-category-" + category.key,
                          disabled: category.disabled,
                          checked: _vm.isChecked(category)
                        },
                        on: {
                          change: function($event) {
                            return _vm.categoryChanged(category)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(category.title) + "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c("Button", {
                  attrs: { text: "Alle erlauben", bluegray: "", uppercase: "" },
                  on: {
                    click: function($event) {
                      return _vm.save(true)
                    }
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: { text: "Einstellungen übernehmen", uppercase: "" },
                  on: {
                    click: function($event) {
                      return _vm.save(false)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "details" },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showDetails = !_vm.showDetails
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.showDetailsLinkText) +
                        "\n\t\t\t\t"
                    ),
                    !_vm.showDetails
                      ? _c("Icon", { attrs: { icon: "arrow-right" } })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showDetails
                  ? [
                      _vm._l(_vm.categories, function(category) {
                        return _c(
                          "div",
                          { key: category.key, staticClass: "category" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "title",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.toggleCookies(category)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(category.title) +
                                    " (" +
                                    _vm._s(category.cookies.length) +
                                    ")\n\t\t\t\t\t\t"
                                ),
                                !_vm.isShowCookies(category)
                                  ? _c("Icon", {
                                      attrs: { icon: "arrow-right" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(_vm._s(category.description))
                            ]),
                            _vm._v(" "),
                            _vm.isShowCookies(category)
                              ? _c(
                                  "div",
                                  { staticClass: "cookies" },
                                  _vm._l(category.cookies, function(cookie) {
                                    return _c(
                                      "div",
                                      {
                                        key: cookie.name,
                                        staticClass: "cookie"
                                      },
                                      [
                                        _c("div", { staticClass: "name" }, [
                                          _vm._v(_vm._s(cookie.name))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "description" },
                                          [_vm._v(_vm._s(cookie.description))]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "duration" }, [
                                          _c("span", [
                                            _vm._v("Speicherdauer:")
                                          ]),
                                          _vm._v(" " + _vm._s(cookie.duration))
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "category" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Über Cookies")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _c("p", [
                            _vm._v(
                              "Cookies sind kleine Datenpakete, die zwischen Ihrem Browser und unserem Webserver\n\t\t\t\t\t\t\tausgetauscht werden. Cookies können nur Informationen speichern, die von Ihrem Browser\n\t\t\t\t\t\t\tgeliefert werden."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Je nach Verwendungszweck sind Cookies technisch erforderlich oder werden für Statistik-\n\t\t\t\t\t\t\toder Marketingzwecke genutzt. Die Verwendung von technisch erforderlichen Cookies beruht\n\t\t\t\t\t\t\tauf unserem berechtigten Interesse am technisch einwandfreien Betrieb und an der\n\t\t\t\t\t\t\treibungslosen Funktionalität unserer Website. Die Verwendung von Statistik- und\n\t\t\t\t\t\t\tMarketing-Cookies benötigt eine Einwilligung. Diese ist freiwillig und kann jederzeit\n\t\t\t\t\t\t\tfür die Zukunft durch den Aufruf der Cookie Einstellungen widerrufen werden."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Sie können Ihren Browser auch so einstellen, dass das Speichern von Cookies generell\n\t\t\t\t\t\t\tverhindert wird. Einmal gesetzte Cookies können Sie jederzeit wieder löschen. Wie all\n\t\t\t\t\t\t\tdies im Einzelnen funktioniert, finden Sie in der Hilfe-Funktion Ihres Browsers. Bitte\n\t\t\t\t\t\t\tbeachten Sie, dass eine generelle Deaktivierung von Cookies gegebenenfalls zu\n\t\t\t\t\t\t\tFunktionseinschränkungen auf unserer Website führen kann."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Nähere Informationen, welche Daten in Cookies gespeichert, zu welchen Zwecken diese\n\t\t\t\t\t\t\tverwendet und für wie lange Daten gespeichert werden, erhalten Sie in unserer\n\t\t\t\t\t\t\tDatenschutzerklärung und in unserem Cookie Banner."
                            )
                          ])
                        ])
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }